import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const makeBrandsActive = async (data: number[]) => {
	const url = "/homepage/admin/app-branding/publish/";

	const response = await cmsClient.post<unknown>(url, data);

	return response.data;
};

const useMakeAppBrandsActive = () => {
	const queryClient = useQueryClient();

	const onSuccess = async () => {
		toast.success(
			<CustomToast type="Success" message="App brand is active now" />,
			{ hideProgressBar: true }
		);

		queryClient.invalidateQueries(["active-app-brand"]);
		queryClient.invalidateQueries(["app-brand-library"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(makeBrandsActive, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useMakeAppBrandsActive;
